import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssesmentListComponent } from './components/assesment-list/assesment-list.component';
import { AssessmentReviewComponent } from './components/assessment-review/assessment-review.component';
import { AssessmentsComponent } from './components/assessments/assessments.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { InstructionComponent } from './components/instruction/instruction.component';
import { QuestionairesComponent } from './components/questionaires/questionaires.component';

const routes: Routes = [
  {
    path: 'assessments',
    children: [
      {
        path: '',
        component: AssessmentsComponent,
      },
      {
        path: 'list',
        component: CategoriesComponent,
      },
      {
        path: ':assessmentId/welcome',
        component: InstructionComponent,
      },
      {
        path: ':assessmentId/testing_in_progress',
        component: QuestionairesComponent
      },
      {
        path: ':assessmentId/review',
        component: AssessmentReviewComponent
      },
      {
        path: 'assesmentList/:id',
        component: AssesmentListComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssessmentRoutingModule {}
